<div fxLayout="row" fxLayoutAlign="start center" class="loader">
    <div class="ball-pulse-sync">
        <div style="background-color: #b1272f"></div>
        <div style="background-color: #ec761e"></div>
        <div style="background-color: #ef8b24"></div>
    </div>
    <p>Loading</p>
</div>
